import React from "react";
import { Order } from "@/types";
import OrderTransactionsTable from "@/components/organisms/OrderTransactionsTable";
import { DEFAULT_ORDER_TRANSACTION_COLUMN } from "@/components/organisms/OrderTransactionsTable/const/default";

interface TransactionTabContentProps {
  order: Order;
}

const TransactionTabContent: React.FC<TransactionTabContentProps> = ({ order }) => {
  return (
    <div>
      {/* Purchase order === show seller, Sell order/Auction === show buyer */}
      <OrderTransactionsTable order={order} visibleColumns={DEFAULT_ORDER_TRANSACTION_COLUMN} />
    </div>
  );
};

export default TransactionTabContent;
